import { Root } from '@yoast/ui-library';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import './utils/chartSetup'; // Initialize Chart.js registration

import App from './App';
import { setApiBaseUrl } from './orval/custom-instance';
import { reportWebVitals, sendToAnalytics } from './utils/webVitals';

// Set API base URL for development
if (import.meta.env.DEV || import.meta.env.NODE_ENV === 'development' || import.meta.env.VITE_API_BASE_URL ) {
  setApiBaseUrl(
    import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1',
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Root context={{ isRtl: false }}>
        <App />
      </Root>
    </BrowserRouter>
  </StrictMode>,
);

// Measure and report web vitals
reportWebVitals(sendToAnalytics);
